require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-181-procurement-tracking-only-available-on-the-builder-edition.json") })
        }
      }, "path---article-181-procurement-tracking-only-available-on-the-builder-edition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-181-procurement-tracking-only-available-on-the-builder-edition!./.cache/json/article-181-procurement-tracking-only-available-on-the-builder-edition.json
// module id = 530
// module chunks = 231608221292675